import prebidConfigGenerator from '../ad-config/src';

export const commandFactory = (commandFactoryParams, bidsBackHandler) => {
    return function command() {
        const {
            pbjs,
            timeout,
            pageType,
            deviceType,
            screenSize,
            categoryL1,
            categoryL2,
            categoryL3,
            keywords,
            vipAdId,
            ppid,
            isNexx360,
        } = commandFactoryParams;

        const publisherProvidedEids =
            ppid
                ? [
                      {
                          source: 'gumtree.com',
                          uids: [
                              {
                                  id: ppid,
                                  atype: 1,
                                  ext: {
                                      stype: 'ppuid',
                                  },
                              },
                          ],
                      },
                  ]
                : undefined;

        const config = {
            gptPreAuction: {
                enabled: true,
                useDefaultPreAuction: true,
            },
            enableTIDs: true,
            consistentTIDs: true,
            ortb2: {
                site: {
                    ext: {
                        data: {
                            ...(categoryL1 && { l1Category: categoryL1 }),
                            ...(categoryL2 && { l2Category: categoryL2 }),
                            ...(categoryL3 && { l3Category: categoryL3 }),
                            ...(screenSize && { SR: screenSize }),
                        },
                    },
                },
            },
            priceGranularity: {
                buckets: [
                    {
                        max: 10,
                        increment: 0.01,
                    },
                    {
                        max: 30,
                        increment: 0.1,
                    },
                ],
            },
            userSync: {
                filterSettings: {
                    iframe: {
                        bidders: '*', // '*' represents all bidders
                        filter: 'include',
                    },
                },
                userIds: [
                    {
                        name: 'identityLink',
                        params: {
                            pid: '13291',
                            notUse3P: false,
                        },
                        storage: {
                            type: 'html5',
                            name: 'idl_env',
                            expires: 7,
                            refreshInSeconds: 1800,
                        },
                    },
                    {
                        name: 'sharedId',
                        storage: {
                            type: 'cookie',
                            name: '_sharedID',
                            expires: 365,
                        },
                    },
                    ...(publisherProvidedEids
                        ? [
                              {
                                  name: 'pubProvidedId',
                                  params: {
                                      eids: publisherProvidedEids,
                                  },
                              },
                          ]
                        : []),
                    {
                        name: 'pairId',
                        params: {
                            liveramp: {
                                storageKey: '_lr_pairId',
                            },
                        },
                    },
                    { 
                        name: 'criteo',

                    },
                ],
                syncDelay: 3000,
            },
            consentManagement: {
                gdpr: {
                    cmpApi: 'iab',
                    defaultGdprScope: true,
                    timeout: 5000,
                    rules: [
                        {
                            purpose: 'storage',
                            enforcePurpose: true,
                            enforceVendor: true,
                            vendorExceptions: ['permutive'],
                        },
                    ],
                },
            },
            bidderSettings: {
                standard: {
                    storageAllowed: ['cookie'],
                },
                nexx360:{
                    storageAllowed: true,
                },
                msft:{
                    storageAllowed: true,
                },
                ix:{
                    storageAllowed: true,
                },
                amx:{
                    storageAllowed: true,
                },
            },
            bidderTimeout: timeout,
            alwaysIncludeDeals: true,
            enableSendAllBids: false,
            realTimeData: {
                dataProviders: [
                    {
                        name: 'permutive',
                        params: {
                            acBidders: ['nexx360','msft', 'rubicon', 'ozone', 'pubmatic', 'ix'],
                        },
                    },
                ],
            },
        };

        const adUnitsFromPrebidConfigGenerator = prebidConfigGenerator(
            pageType,
            deviceType,
            screenSize,
            categoryL1,
            categoryL2,
            categoryL3,
            keywords,
            vipAdId,
            isNexx360
        );

        pbjs.removeAdUnit();

        pbjs.addAdUnits(adUnitsFromPrebidConfigGenerator);

        pbjs.setConfig(config);

        pbjs.enableAnalytics([
            {
                provider: 'atsAnalytics',
                options: {
                    pid: '13291',
                },
            },
        ]);

        pbjs.requestBids({
            timeout,
            bidsBackHandler,
        });
    };
};
